export class BookingItemLastErrorStatusModel {
  id: number = -1;
  lastErrorStatus: string = undefined;
  lastErrorMessage?: string;
}
